import { render, staticRenderFns } from "./ProgressionTable.vue?vue&type=template&id=6f859430&scoped=true&"
import script from "./ProgressionTable.vue?vue&type=script&lang=js&"
export * from "./ProgressionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f859430",
  null
  
)

export default component.exports